/* unplugin-vue-components disabled */import { render } from "./userTermsEN.vue?vue&type=template&id=7f3b03fb&scoped=true"
import script from "./userTermsEN.vue?vue&type=script&lang=js"
export * from "./userTermsEN.vue?vue&type=script&lang=js"

import "./userTermsEN.vue?vue&type=style&index=0&id=7f3b03fb&scoped=true&lang=css"

import exportComponent from "E:\\IDEAWorkSpace\\parent-net-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f3b03fb"]])

export default __exports__